module.exports = __webpack_public_path__ + "static/img/logo1.976087a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo1.png
// module id = 1162
// module chunks = 68